import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./newsletter.css";

export default function Newsletter() {
  return (
    <section className="broadcast">
      <div className="broadcast-card">
        <h2 className="broadcast-title">Join the Inner Circle</h2>
        <p className="broadcast-desc">
          Get early access to new drops, exclusive offers, and style notes
          delivered to your WhatsApp.
        </p>
        <a
          href="https://whatsapp.com/channel/your-channel-id"
          target="_blank"
          rel="noopener noreferrer"
          className="broadcast-btn"
        >
          <FaWhatsapp className="broadcast-icon" />
          Join WhatsApp Broadcast
        </a>
      </div>
    </section>
  );
}
